// SPDX-License-Identifier: AGPL-3.0-or-later
import type {MessageAttachment} from '@app/vendor/schema/domains/message/MessageResponseSchemas';

const IMAGE_TYPES = ['image/png', 'image/jpeg', 'image/jpg', 'image/gif', 'image/webp', 'image/avif'];
const VIDEO_TYPES = ['video/mp4', 'video/webm', 'video/quicktime'];
const AUDIO_TYPES = [
	'audio/mpeg',
	'audio/mp3',
	'audio/ogg',
	'audio/wav',
	'audio/x-wav',
	'audio/wave',
	'audio/webm',
	'audio/flac',
	'audio/x-flac',
	'audio/aac',
	'audio/x-aac',
	'audio/mp4',
	'audio/opus',
];
function isImageType(contentType?: string): boolean {
	return contentType ? IMAGE_TYPES.includes(contentType) : false;
}
function isVideoType(contentType?: string): boolean {
	return contentType ? VIDEO_TYPES.includes(contentType) : false;
}
function isAudioType(contentType?: string): boolean {
	return contentType ? AUDIO_TYPES.includes(contentType) : false;
}
const hasDimensions = (attachment: MessageAttachment): boolean =>
	typeof attachment.width === 'number' && typeof attachment.height === 'number';
export const isMediaAttachment = (attachment: MessageAttachment): boolean =>
	hasDimensions(attachment) &&
	(isImageType(attachment.content_type) ||
		isVideoType(attachment.content_type) ||
		isAudioType(attachment.content_type));
export function splitMediaAndFileAttachments(attachments: ReadonlyArray<MessageAttachment>): {
	mediaAttachments: Array<MessageAttachment>;
	fileAttachments: Array<MessageAttachment>;
} {
	const mediaAttachments: Array<MessageAttachment> = [];
	const fileAttachments: Array<MessageAttachment> = [];
	for (const attachment of attachments) {
		if (isMediaAttachment(attachment)) {
			mediaAttachments.push(attachment);
		} else {
			fileAttachments.push(attachment);
		}
	}
	return {mediaAttachments, fileAttachments};
}
